import { useEffect, useRef, useState } from "react";

export default function Timer({
  timer,           // booléen : true = stop timer
  onFinish,        // callback à la fin
  onSendTime,      // callback temps final
  onGetTime,       // callback pour récupérer le temps actuel depuis le parent
  hasLimit = true,
  limit = 120,
}) {
  const [secondsElapsed, setSecondsElapsed] = useState(0);

  const startTimeRef      = useRef(null);
  const intervalRef       = useRef(null);
  const secondsElapsedRef = useRef(0);
  const pauseTimeRef = useRef(null);

  //  FIX CRITIQUE : stocker les callbacks dans des refs.
  // Sans ça, onFinish/onSendTime (nouvelles références à chaque render parent)
  // étaient dans les deps → l'effet redémarrait toutes les 250ms →
  // setSecondsElapsed → re-render MixedWords → nouvelles refs → boucle infinie.
  const onFinishRef   = useRef(onFinish);
  const onSendTimeRef = useRef(onSendTime);
  const onGetTimeRef  = useRef(onGetTime);

  useEffect(() => { onFinishRef.current   = onFinish;   }, [onFinish]);
  useEffect(() => { onSendTimeRef.current = onSendTime; }, [onSendTime]);
  useEffect(() => { onGetTimeRef.current  = onGetTime;  }, [onGetTime]);

  const formatTime = (totalSeconds) => {
    const s = Math.max(0, Math.floor(totalSeconds));
    const minutes = Math.floor(s / 60);
    const seconds = s % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  //  Deps : seulement les valeurs primitives stables (timer, hasLimit, limit)
  useEffect(() => {
    if (timer) {
      // 👉 ON PAUSE
      clearInterval(intervalRef.current);
      pauseTimeRef.current = Date.now();
      return;
    }

    // 👉 ON REPREND
    if (pauseTimeRef.current) {
      const pauseDuration = Date.now() - pauseTimeRef.current;
      startTimeRef.current += pauseDuration;
      pauseTimeRef.current = null;
    }

    if (!startTimeRef.current) {
      startTimeRef.current = Date.now() - secondsElapsedRef.current * 1000;
    }

    intervalRef.current = setInterval(() => {
      const diff = Math.floor((Date.now() - startTimeRef.current) / 1000);

      if (hasLimit && diff >= limit) {
        clearInterval(intervalRef.current);
        secondsElapsedRef.current = limit;
        setSecondsElapsed(limit);
        onSendTimeRef.current?.(formatTime(limit));
        onFinishRef.current?.();
      } else {
        secondsElapsedRef.current = diff;
        setSecondsElapsed(diff);
      }
    }, 250);

  return () => clearInterval(intervalRef.current);
}, [timer, hasLimit, limit]); //  onFinish / onSendTime retirés des deps

  //  onGetTime exposé une seule fois — lit secondsElapsedRef (toujours à jour)
  useEffect(() => {
    onGetTimeRef.current?.(() => formatTime(secondsElapsedRef.current));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const secondsRemaining = hasLimit ? limit - secondsElapsed : null;

  return (
    <div id="pTimer">
      <span id="spanTimer">{formatTime(secondsElapsed)}</span>
      {hasLimit && (
        <>
          {" / "}
          <span id="spanCountdown">{formatTime(secondsRemaining)}</span>
        </>
      )}
    </div>
  );
}